
define('text!side-menu/side-menu.html',[],function () { return '<div class="side-menu-container" data-bind="react: reactOptions"></div>\n';});

